import { render } from "./CommonProblem.vue?vue&type=template&id=8a10a02c&scoped=true"
import script from "./CommonProblem.vue?vue&type=script&lang=js"
export * from "./CommonProblem.vue?vue&type=script&lang=js"

import "./CommonProblem.vue?vue&type=style&index=0&id=8a10a02c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a10a02c"]])

export default __exports__